<template>
  <div class="size-7 min-w-[28px] relative shrink-0">
    <DropdownMenu>
      <DropdownMenuTrigger as-child>
        <button type="button">
          <Avatar
            :size="size"
            :class="avatarClass"
            :rounded="true"
            :color="getColor"
            :src="getAvatarUrl || getGravatarUrl"
            :alt="getShortName"
            :initials="getShortName"
          />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent :side-offset="12" :align-offset="-6" :align="'end'">
        <DropdownMenuLabel>
          {{ getEmail }}
        </DropdownMenuLabel>
        <DropdownMenuItem @click="onClickAccount">
          <SvgIcon
            class="opacity-50 ml-0 mr-2.5 my-0"
            icon="app-icons/account"
            :width="'15'"
            :height="'15'"
          />
          <span>My Account</span>
        </DropdownMenuItem>
        <DropdownMenuItem @click="logout">
          <SvgIcon
            class="opacity-50 ml-0 mr-2.5 my-0"
            icon="app-icons/logout"
            :width="'15'"
            :height="'15'"
          />
          <span>Logout</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import SvgIcon from '@ui/components/SvgIcon.vue';
import { Avatar } from '@ui/components/avatar';
import mixpanelSingleton from '@/mixpanel/mixpanelSingleton.js';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
} from '@ui/components/dropdown-menu';
import requests from '../../vuex/requests.js';

const store = useStore();
const router = useRouter();

defineProps({
  size: {
    type: String,
    default: 'medium',
  },
  avatarClass: {
    type: String,
    default: '',
  },
});

const getEmail = computed(() => store.getters['user/account/getEmail']);
const getShortName = computed(() => store.getters['user/account/getShortName']);
const getColor = computed(() => store.getters['user/account/getColor']);
const getGravatarUrl = computed(
  () => store.getters['user/account/getGravatarUrl']
);
const getAvatarUrl = computed(() => store.getters['user/account/getAvatarUrl']);

const logout = () => {
  requests.logout().then(response => {
    // TrackEvent - Mixpanel reset identity
    mixpanelSingleton.reset();
    window.location = response.data.redirect;
  });
};

const onClickAccount = () => {
  router.push('/account');
};
</script>
